import { render, staticRenderFns } from "./loading-button.component.vue?vue&type=template&id=342b4fb8&scoped=true&"
import script from "./loading-button.component.ts?vue&type=script&lang=ts&"
export * from "./loading-button.component.ts?vue&type=script&lang=ts&"
import style0 from "./loading-button.component.scss?vue&type=style&index=0&id=342b4fb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342b4fb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
